module.exports = __webpack_public_path__ + "img/ap3-favorable.0d5a57c1.png";